import { BtnProps } from '../useBtnOpt';
export function isValidKey(
  key: string | number | symbol,
  object: object
): key is keyof typeof object {
  return key in object;
}
export function uuid() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = (Math.random() * 16) | 0,
      v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}
/**
 * 数据分组
 * @param { array } array 需要进行分组的数据
 * @param { string } key 进行分组时依据的键名
 * @returns { array } 二维数组形
 */
export function dataGroupingToDeepArray(
  array: BtnProps[],
  key: string
): BtnProps[][] {
  if (!key) return [array];
  const aMap: string[] = [];
  const aResult = [];
  for (let i = 0; i < array.length; i++) {
    const item = array[i];
    if (isValidKey(key, item) && aMap.indexOf(item[key]) === -1) {
      aResult.push([item]);
      aMap.push(item[key]);
    } else {
      if (isValidKey(key, item)) {
        const index = aMap.indexOf(item[key]);
        aResult[index].push(item);
      }
    }
  }
  return aResult;
}
/**
 * 数组扁平化
 * @param arr
 * @return {*}
 */
export function arrayFlatten(arr: number[]) {
  return arr.flat(Infinity);
}
